import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DS, fadeInSx, overlayButtonSx } from '../designTokens';

type Props = {
  messageKey: string;
  onRetry: () => void;
  onClose: () => void;
};

const CallFailed = ({ messageKey, onRetry, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        flex: 1,
        display: 'grid',
        placeItems: 'center',
        p: 3,
        borderRadius: '20px',
        bgcolor: DS.stage,
        ...fadeInSx,
      }}
    >
      <Box
        sx={{
          maxWidth: 380,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontFamily: DS.fontDisplay,
            fontWeight: 600,
            fontSize: 20,
            color: DS.linen,
          }}
        >
          {t(messageKey)}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.25 }}>
          <Box
            component="button"
            onClick={onRetry}
            sx={{
              ...overlayButtonSx,
              border: 'none',
              bgcolor: DS.linen,
              color: DS.deepTeal,
            }}
          >
            {t('videoVisit.retry')}
          </Box>
          <Box
            component="button"
            onClick={onClose}
            sx={{
              ...overlayButtonSx,
              bgcolor: 'transparent',
              border: `1.5px solid ${DS.onDarkBorder}`,
              color: DS.linen,
            }}
          >
            {t('videoVisit.close')}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CallFailed;
